export enum Color {
  white = "#ffffff",
  offWhite = "#f4f4f4",
  lightGray = "#dddddd",
  gray = "#cccccc",
  mediumGray = "#666666",
  darkGray = "#434343",
  green = "#66aa44",
  darkGreen = "#337711",
  yellow = "#ffdd66",
  red = "#ee6666",
  virtualRed = "#e82f2f",
  soilBackground = "#c39f7a",
  labelBackground = "#8d7157",
  templateSoilBkgd = "#dddddd",
  gridGray = "#333333",
  gridSoil = "#ccaa88",
  templateGridSoil = "#f4f4f4",
  soilCloud = "#90612f",
  black = "#000000",
  orange = "#ffa500",
  darkOrange = "#ff7700",
  blue = "#3377dd",
  cyan = "#14bee6",
  magenta = "#a64d79",
  curveBlue = "#9fc5e8",
  curveDarkBlue = "#488cc9",
  curveGreen = "#b6d7a8",
  curveDarkGreen = "#95be84",
  curvePurple = "#b4a7d6",
  curveDarkPurple = "#9383bc",
}
